import './App.css';
//import reportWebVitals from './reportWebVitals';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'boxicons/css/boxicons.min.css';
import Header from './components/Header.js';
import HeroImage from './components/HeroImage.js';
import Carousel from './components/Carousel.js';
import Contact from "/Users/estefania/m-y-bricks/src/components/Contact.js";

const App = () => {
    const ecoMedia = [
      [
        { type: 'video', src: "/videoChapasEco.mp4"},
        { type: 'image', src: "/chapasEco.jpg"},
        { type: 'video', src: '/videoConstEco.mp4' },
      ],
      [
        { type: 'image', src: "/ladrillosMC.jpg"},
        { type: 'image', src: "/construccionEco.jpg" },
        { type: 'image', src: "/ladrillosConstruc.jpg"},
      ]
    ];

    const traditionalMedia = [
      [
        { type: 'image', src: "/proyectoLadrillos.jpg" },
        { type: 'image', src: "/ProyectoHormigon.jpg" },
        { type: 'image', src: "/Proyecto Hormigon.jpg" }
      ],
      [
        { type: 'image', src: "/planoCesto.jpg" },
        { type: 'image', src: "/cestoBascket.jpg" },
        { type: 'image', src: "/cestoFinal.jpg" }
      ]
    ];

  return (
    <div>
      <Header />
      <div id="inicio">
        <HeroImage />
      </div>
      <section id="about" className="section about-section">
        <h2 class="about-title">Sobre Nosotros</h2>
        <div className="title-decoration">
          <span className="dot"></span> {/* El punto o detalle en el centro */}
        </div> 
        <div className="about-container">
            <img src="/ladrillosMC.jpg"
            alt="Sobre nosotros"
            className="about-image"/>
          <div className="about-text">
            <p>
              Somos un emprendimiento de la ciudad de Berisso, Argentina,
              dedicado a la fabricación de ladrillos sustentables. Estamos
              comprometidos con el medio ambiente y la innovación. <br></br>
              El <b>Ladrillo Ecológico</b> es una alternativa arquitectónica sostenible 
              que tiene como objetivo reducir la huella ambiental generada por los 
              materiales de construcción.
            </p>
          </div>
        </div>
      </section>
      <section id="services" className="section services-section">
        <h2 className="services-title">Servicios</h2>
        <div className="title-decoration">
          <span className="dot"></span> {/* El punto o detalle en el centro */}
        </div> 
        <div className="services-container">
          <div className="service-box">
            <img src="/ladrillosConstruc.jpg" alt="Fabricación de ladrillos ecológicos" className="service-image" />
            <h3>Fabricación de ladrillos ecológicos</h3>
            <p>Producción innovadora y sostenible de ladrillos respetuosos con el medio ambiente.</p>
          </div>
          <div className="service-box">
            <img src="/construccion.jpg" alt="Consultoría en construcción sustentable" className="service-image" />
            <h3>Consultoría en construcción sustentable</h3>
            <p>Asesoramiento especializado para proyectos ecológicos y sostenibles.</p>
          </div>
          <div className="service-box">
            <img src="/constructor.jpg" alt="Construcción" className="service-image" />
            <h3>Construcción de Viviendas Sustentables</h3>
            <p>Implementamos técnicas modernas para edificaciones responsables y eficientes.</p>
          </div>
        </div>
      </section>
      <section id="projects" className="section">
        <h2>Proyectos</h2>
        <div className="title-decoration">
          <span className="dot"></span>
        </div> 
        {/* Primer carrusel con descripción */}
        <div className="carousel-container">
          <Carousel
            title="Proyectos de Construcción Ecologica ♻️"
            description="Descubre nuestros proyectos diseñados con un enfoque sostenible, utilizando materiales de construcción como ladrillos y chapas, elaborados a partir de materiales reciclados para reducir el impacto ambiental."
            images={ecoMedia} />
        </div>
        {/* Segundo carrusel con descripción */}
        <div className="carousel-container">
          <Carousel
            title="Proyectos de Construcción Tradicional"
            description="Descubre nuestros proyectos de construcción tradicional, realizados con materiales clásicos como hormigón, ladrillos comunes o huecos, cerámicos y mucho más, garantizando calidad y durabilidad en cada detalle."
            images={traditionalMedia} />
        </div>
        {/*<Carousel />*/}
      </section>
      <Contact/>
      <footer>
        <div className="container">
          <div className="copyright">
            &copy; <strong><span>M & Bricks</span></strong>. Todos los derechos reservados.
            <div className="social-links mt-3">
              <a href="https://www.facebook.com/profile.php?id=100083522100683&locale=es_LA" 
              className="facebook"><i className="bx bxl-facebook"></i></a>
              <a href="https://api.whatsapp.com/send?phone=2213533791" 
              className="whatsapp"><i className="bx bxl-whatsapp"></i></a>
          </div>
          </div>
          <div className="credits">
            Designed by <a href="https://.com/">EsWeb</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
